import React from "react";
import CollegeHomeContainer from "../Container/CollegeHomeContainer";
import "react-circular-progressbar/dist/styles.css";
import "./Dashboard.css";
// import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import { connect } from "react-redux";
import Tour from 'reactour';
import CollegeDashboardContents from "./CollegeDashboardContents";
import ConfirmAndCancel from '../../Components/Buttons/ConfirmAndCancel';
import Modal from '../../Components/Modal/Modal'
import { API } from "../../API"
import { notify } from "react-notify-toast";
import { withRouter } from 'react-router-dom';
import Auth from "../../Auth/Auth";
import ConfirmButton from "../../Components/Buttons/ConfirmButton";
import { updateInstitutionInfo } from "../../redux/college/college.actions";

class CollegeDashboard extends React.Component {
  state = {
    showTour: (this.props.location.state && this.props.location.state.firstTime) || false,
    showActiveAccountModal: this.props.user.archived,
    showContractPopup: false,
    showFinanceSettingPopup: false
  };

  tabs = [
    {
      pathname: "/CollegeDashboard",
      text: "Dashboard",
      active: true,
    },
    {
      pathname: "/profile",
      text: this.props.user?.is_childcare_centre ? "Centre Profile" : "Institute Profile",
    },
  ];

  stepsForTour = [
    {
      content:
        'Welcome to ReadyTeacher! Whether you would like to hire a Teacher instantly or advertise a vacancy, ' +
        'or simply browse our Teachers, here’s how to get the process started.',
    },
    {
      selector: '.inactiveTabButton',
      content:
        "Let’s start with your Institution Profile. Please add as much information as possible, taking care to " +
          "upload your organisation logo and courses you deliver - you'll only be able to Make a Booking or publish " +
          "a Job Vacancy Listing once these items are completed."
    },
    {
      selector: '.dd-menu',
      content:
        'Next, let’s record your Institution Settings relating to your Campuses, Personnel and Timetable. ' +
        'These records are crucial to ensuring your Booking and/or Job Listing requirements are delivered with' +
        ' accuracy by our Teachers. Navigate to Institution Settings via Menu.',
    },
    {
      selector: '.makeabooking',
      content:
        'It’s easy to make a Booking via the button in the top toolbar or via this quick link on your dashboard. ' +
        'When you click on Make a Booking, you will see your recorded entries from Institution Settings to select from. ' +
        'After submitting, you will receive a confirmation email.'
    },
    {
      content: 'Next, let\'s move onto the quick action links',
      action: () => document.querySelector('.quick-action-links').scrollIntoView({block: "center"})
    },
    {
      selector: '.make-booking-link',
      content:
          'In addition to the Book Now button at the top of the screen, you can use this quick link to Make a Booking.'
    },
    {
      selector: '.post-job-link',
      content: 'Click here to create a Job Listing for a current vacancy. Existing Ready Teachers will be notified ' +
          'once you publish your listing, and we will add it to our website to invite new teachers to apply. You ' +
          'can Request to Interview, Favourite and Block teachers as you wish.'
    },
    {
      selector: '.search-teachers-link',
      content: 'Just looking? You\'ve come to the right quick link. Peruse our Teachers, view their Profiles and ' +
          'add them to your Favourites List.'
    },
    {
      selector: '.view-favourites-link',
      content: 'Click here to go straight to your list of favourite teachers and book them instantly.'
    },
    {
      selector: '.send-lesson-plan-link',
      content: 'Chat function - coming soon.'
    },
    {
      content: 'Now, let\'s move onto the booking summary.',
      action: () => document.querySelector('.upcoming-inner').scrollIntoView({block: "center"})
    },
    {
      selector: '.upcoming-inner',
      content: 'Here is a summary of your next one or two bookings and the last completed booking.'
    },
    {
      selector: '.booking-title',
      content: 'This is where you will see the Teacher who has been allocated to the job. Click on View Profile to ' +
          'learn more about your Ready Teacher.'
    },
    {
      selector: '.booking-details',
      content: 'All your job details are contained here. If something is incorrect, contact our team immediately by ' +
          'emailing hello@readyteacherco.com or phoning 1800READYT.'
    },
    {
      selector: '.center-link',
      content: 'Click on Job Details to view your Job List and more functions such as Cancel Booking.'
    },
  ];

  closeShowTour = () => {
    this.setState({ showTour: false });
  }

  openTour = () => {
    this.setState({ showTour: true });
  };

  reActiveAccount = async () => {
    API.activeCustomerAccount().then((result) => {
      notify.show("Active account successfully. Please login again.")
      Auth.logout()
      this.props.history.push("/LoginAsInstitution")
    })
    // this.setState({showActiveAccountModal: false})
  }

  componentDidMount = () => {
    API.getInstitutionDataById(this.props.user.institution_id)
      .then((res) => {
        const inst = res?.data;
        this.props.updateInstInfo(inst);
        this.setState({
          showContractPopup: (inst?.is_childcare_centre && !inst?.new_pricing_contract?.is_accepted) || (!inst?.is_childcare_centre && !inst?.new_pricing_contract?.is_accepted),
          showFinanceSettingPopup: !inst?.payment_setting || !inst?.budget
        })
      })
      .catch(err => {
        console.log('err', err)
      })
  }

  render() {
    return (
      <CollegeHomeContainer
        user={this.props.user}
        institution={this.props.institution}
        isViewAsCollege={true}
        tabs={this.tabs}
        hideViewBar
        offset={true}
        viewbookings={true}
        removeTopMargin
      >
        <Tour
          showCloseButton={false}
          accentColor='#79cbca'
          className='tourContent'
          steps={this.stepsForTour}
          isOpen={this.state.showTour}
          onRequestClose={this.closeShowTour}
        >
          <div className='tour-dot' onClick={this.closeShowTour}/>
        </Tour>
        <CollegeDashboardContents
          user={this.props.user}
          institution={this.props.institution}
          campuses={this.props.campuses}
          personnel={this.props.personnel}
          classes={this.props.classes}
          openTour={this.openTour}
        />
        <Modal
          header="REACTIVATE YOUR ACCOUNT"
          show={this.state.showActiveAccountModal}
          className="confirm-number-modal"
        >
          <div className="text-center">Your account was archived. Do you wish to reactivate your account?</div>

          <ConfirmAndCancel
            onCancel={() => {
              this.setState({showActiveAccountModal: false})
            }}
            cancelText='Not Now'
            onConfirm={() => this.reActiveAccount()}
            confirmText='Active'
          />
        </Modal>

        <Modal
          className="w-50"
          header="You have not update your Finance Setting and Budget Setting"
          show={this.state.showFinanceSettingPopup}
        >
          <p className="center-text fs-20">
            Please view and update your Finance Setting and Budget Setting to continue.
          </p>
          <p className="center-text mt-3" style={{'lineHeight': 'normal'}}>
            <small>
              You can update your Finance Setting and Budget Setting in the Institution Settings.
            </small>
          </p>
          <br />
          <div className="d-flex justify-center">
            <ConfirmButton onClick={() => 
              !this.props.institution?.payment_setting ? this.props.history.push("/FinanceSetting") : this.props.history.push("/BudgetSetting")}>
              Update Now
            </ConfirmButton>
          </div>
        </Modal>

        <Modal
          className="w-50"
          header="We've updated our Terms and Conditions"
          show={this.state.showContractPopup}
        >
          <p className="center-text fs-20">
            Please view and accept our Terms and Conditions to continue. We'll email you a copy upon completion.
          </p>
          <p className="center-text mt-3" style={{'lineHeight': 'normal'}}>
            <small>
            New Pricing Schedule for ELICOS & VET added as appendix.
            </small>
          </p>
          <br />
          <div className="d-flex justify-center">
            <ConfirmButton onClick={() => this.props.history.push("/SignContract")}>
              View Terms and Conditions
            </ConfirmButton>
          </div>
        </Modal>
      </CollegeHomeContainer>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.college.user,
    institution: state.college.institution,
    campuses: state.college.campuses,
    personnel: state.college.personnel,
    classes: state.college.classes,
  };
}

const mapDispatchToProps = (dispatch) => ({
  updateInstInfo: (inst) => dispatch(updateInstitutionInfo(inst)),
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CollegeDashboard));
